import { Button } from '@seeqdev/qomponents';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.constants';
import type { ButtonProps } from '@seeqdev/qomponents';

export interface ButtonIF extends ValidatingFormComponent<string> {
  component: 'ButtonFormComponent';
  onClick: () => void | Promise<void>;
  label: string | React.JSX.Element | React.ReactNode;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  disabled?: boolean;
  icon?: string;
  iconStyle?: ButtonProps['iconStyle'];
  iconColor?: string;
  iconPosition?: ButtonProps['iconPosition'];
  iconPrefix?: string;
  tooltip?: string;
  isHtmlTooltip?: boolean;
  tooltipTestId?: string;
  tooltipOptions?: ButtonProps['tooltipOptions'];
  preventBlur?: boolean;
}

/**
 * A wrapper around the `Button` component for use with `FormBuilder`
 */
export const ButtonFormComponent = ({
  onClick,
  label,
  variant,
  size,
  disabled,
  icon,
  iconStyle,
  iconColor,
  iconPosition,
  iconPrefix,
  tooltip,
  isHtmlTooltip,
  tooltipTestId,
  tooltipOptions,
  preventBlur,
  testId,
  extraClassNames,
}: ButtonIF) => {
  return (
    <Button
      onClick={onClick}
      label={label}
      variant={variant}
      size={size}
      disabled={disabled}
      icon={icon}
      iconStyle={iconStyle}
      iconColor={iconColor}
      iconPosition={iconPosition}
      iconPrefix={iconPrefix}
      tooltip={tooltip}
      isHtmlTooltip={isHtmlTooltip}
      tooltipTestId={tooltipTestId}
      tooltipOptions={tooltipOptions}
      preventBlur={preventBlur}
      testId={testId}
      extraClassNames={extraClassNames}
    />
  );
};
